import { useState, useCallback } from 'react';
import { cortesAPI } from '../services/api';

const errorDe = (error, porDefecto) => error.response?.data?.error || porDefecto;

/**
 * Meses cargados (cortes) y el detalle del mes seleccionado: consumo de
 * IBM Cloud agrupado por servicio + recurso.
 */
export const useCortes = (showNotification) => {
  const [cortes, setCortes] = useState([]);
  const [detalle, setDetalle] = useState(null);
  const [loadingLista, setLoadingLista] = useState(true);
  const [loadingDetalle, setLoadingDetalle] = useState(false);

  const loadCortes = useCallback(async () => {
    setLoadingLista(true);
    try {
      const res = await cortesAPI.getAll();
      const lista = res.data.cortes || [];
      setCortes(lista);
      return lista;
    } catch (error) {
      console.error('Error cargando meses:', error);
      showNotification?.('error', 'Consumo mensual', 'No se pudieron cargar los meses');
      return [];
    } finally {
      setLoadingLista(false);
    }
  }, [showNotification]);

  const loadDetalle = useCallback(async (periodo) => {
    if (!periodo) {
      setDetalle(null);
      return;
    }
    setLoadingDetalle(true);
    try {
      const res = await cortesAPI.get(periodo);
      setDetalle(res.data);
    } catch (error) {
      console.error('Error cargando el mes:', error);
      setDetalle(null);
      showNotification?.('error', 'Consumo mensual', errorDe(error, 'No se pudo cargar el mes'));
    } finally {
      setLoadingDetalle(false);
    }
  }, [showNotification]);

  // Devuelve { ok } | { existe: true } (el mes ya estaba y no se pidió reemplazar)
  // | { error }.
  const cargarMes = useCallback(async ({ file, periodo, trm, reemplazar }) => {
    const fd = new FormData();
    fd.append('periodo', periodo);
    if (trm) fd.append('trm', trm);
    if (reemplazar) fd.append('reemplazar', 'true');
    fd.append('file', file);
    try {
      const res = await cortesAPI.cargar(fd);
      return { ok: true, ...res.data };
    } catch (error) {
      if (error.response?.status === 409) return { existe: true };
      console.error('Error cargando el CSV del mes:', error);
      return { error: errorDe(error, 'No se pudo guardar el mes') };
    }
  }, []);

  const setTrm = useCallback(async (id, trm) => {
    try {
      await cortesAPI.setTrm(id, trm);
      setDetalle((d) => (d && d.corte.id === id ? { ...d, corte: { ...d.corte, trm } } : d));
      setCortes((list) => list.map((c) => (c.id === id ? { ...c, trm } : c)));
      return true;
    } catch (error) {
      showNotification?.('error', 'TRM', errorDe(error, 'No se pudo guardar la TRM'));
      return false;
    }
  }, [showNotification]);

  const eliminar = useCallback(async (id) => {
    try {
      await cortesAPI.eliminar(id);
      return true;
    } catch (error) {
      showNotification?.('error', 'Consumo mensual', errorDe(error, 'No se pudo eliminar el mes'));
      return false;
    }
  }, [showNotification]);

  return {
    cortes,
    detalle,
    loadingLista,
    loadingDetalle,
    loadCortes,
    loadDetalle,
    cargarMes,
    setTrm,
    eliminar
  };
};
